// extracted by mini-css-extract-plugin
export var aiStarIcon = "_77-4";
export var closeButton = "_77-6";
export var dismissButton = "_77-3";
export var editImageWithAiContainer = "_77-8";
export var imageUploadWrapper = "_77-7";
export var misspelledWord = "_77-5";
export var spellCheckContainer = "_77-2";
export var spin = "_77-1";
export var spinning = "_77-0";